var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgreeIconFilledd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2743 0.585747L8.83539 7.89838C8.33856 8.38677 8.05658 9.05996 8.05658 9.75954V22.946C8.05658 24.398 9.26507 25.586 10.7421 25.586H22.827C23.9012 25.586 24.868 24.9524 25.2977 23.9888L29.6751 13.9438C30.803 11.3303 28.856 8.42637 25.9691 8.42637H18.3824L19.6581 2.38091C19.7923 1.72092 19.5909 1.04774 19.1075 0.572548C18.3153 -0.193035 17.0531 -0.193035 16.2743 0.585747V0.585747ZM2.68553 25.586C4.16257 25.586 5.37106 24.398 5.37106 22.946V12.3863C5.37106 10.9343 4.16257 9.74634 2.68553 9.74634C1.20849 9.74634 0 10.9343 0 12.3863V22.946C0 24.398 1.20849 25.586 2.68553 25.586Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgreeIconFilledd);
export default __webpack_public_path__ + "static/media/agree-icon-filledd.f0fc945d59c2cc11acd42433547c5cef.svg";
export { ForwardRef as ReactComponent };